var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let workerPromise;
export function getWorker() {
    if (!workerPromise) {
        workerPromise = new Promise(resolve => {
            const worker = new Worker(new URL('./converter-worker', import.meta.url), { type: 'module' });
            function handle(evt) {
                if (evt.data && evt.data.type === 'converter-worker-loaded') {
                    worker.removeEventListener('message', handle);
                    resolve(worker);
                }
            }
            worker.addEventListener('message', handle);
        });
    }
    return workerPromise;
}
let nextIndex = 0;
export function convert(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const worker = yield getWorker();
        const indx = nextIndex++;
        return yield new Promise(resolve => {
            function handler(evt) {
                worker.removeEventListener('message', handler);
                if (evt.data['indx'] === indx)
                    resolve(evt.data['data']);
            }
            worker.addEventListener('message', handler);
            worker.postMessage({ indx, data }, [data]);
        });
    });
}
export function load() {
    return __awaiter(this, void 0, void 0, function* () {
        // Preload worker if it's likely to be necessary
        if (!MediaRecorder.isTypeSupported('video/mp4') && MediaRecorder.isTypeSupported('video/webm;codecs="avc1,opus"')) {
            yield getWorker();
        }
    });
}
